import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import { RemunerationGrid, RemunerationGridRowInput } from './remuneration-grid.model';
import { SalaryIncreaseType } from '../../../../core/models/salary-increase-type';

@Injectable({
  providedIn: 'root',
})
export class RemunerationGridService {
  private readonly baseUrl = `${environment.apiUrl}/remuneration-grid`;
  private readonly savedSubject = new Subject<RemunerationGrid>();
  readonly saved$ = this.savedSubject.asObservable();

  constructor(private http: HttpClient) {}

  getPractices(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/practices`);
  }

  getYears(): Observable<number[]> {
    return this.http.get<number[]>(`${this.baseUrl}/years`);
  }

  getGrid(year: number, practice: string): Observable<RemunerationGrid> {
    return this.http.get<RemunerationGrid>(this.baseUrl, { params: this.params(year, practice) });
  }

  saveGrid(
    year: number,
    practice: string,
    increaseType: SalaryIncreaseType,
    rows: RemunerationGridRowInput[],
  ): Observable<RemunerationGrid> {
    return this.http
      .put<RemunerationGrid>(this.baseUrl, { increaseType, rows }, { params: this.params(year, practice) })
      .pipe(tap((grid) => this.savedSubject.next(grid)));
  }

  private params(year: number, practice: string): HttpParams {
    return new HttpParams().set('year', year).set('practice', practice);
  }
}
